import * as fromRoot from '../../reducers';
import * as TracksReducer from './tracks.reducer';
import * as PointsReducer from './points.reducer';
import * as DrivingReducer from './driving.reducer';
import { Action, ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

export interface TracksState {
  tracks: TracksReducer.State;
  points: PointsReducer.State;
  driving: DrivingReducer.State;
}

export interface State extends fromRoot.State {
  tracksState: TracksState;
}

export const reducers: ActionReducerMap<TracksState, Action> = {
  tracks: TracksReducer.reducer,
  points: PointsReducer.reducer,
  driving: DrivingReducer.reducer,
};

export const selectTrackState = createFeatureSelector<State, TracksState>('tracksState');

export const selectTracks = createSelector(selectTrackState, (state: TracksState) => state.tracks);
export const selectPoints = createSelector(selectTrackState, (state: TracksState) => state.points);
export const selectDriving = createSelector(selectTrackState, (state: TracksState) => state.driving);

export const getRoutes = createSelector(selectTracks, TracksReducer.getRoutes);
export const getRoutesMap = createSelector(selectTracks, TracksReducer.getRoutesMap);
export const getSelectedRoutes = createSelector(selectTracks, TracksReducer.getSelectedRoutes);
export const getChosenRoutes = createSelector(selectTracks, TracksReducer.getChosenRoutes);
export const getHoveredRouteIds = createSelector(selectTracks, TracksReducer.getHoveredRouteIds);
export const getClickedRouteIds = createSelector(selectTracks, TracksReducer.getClickedRouteIds);
export const getClickedStopRouteIds = createSelector(selectTracks, TracksReducer.getClickedStopRouteIds);
export const getHoveredStopRouteIds = createSelector(selectTracks, TracksReducer.getHoveredStopRouteIds);
export const getDate = createSelector(selectTracks, TracksReducer.getDate)
export const areRoutesLoading = createSelector(selectTracks, TracksReducer.areRoutesLoading)
export const getActivePlayer = createSelector(selectTracks, TracksReducer.getActivePlayer)
export const getSelectedVehicles = createSelector(selectTracks, TracksReducer.getSelectedVehicles)
export const getVehiclesDetailsVisibility = createSelector(selectTracks, TracksReducer.getVehiclesDetailsVisibility)
export const getRoutesByParams = createSelector(selectTracks, TracksReducer.getRoutesByParams)

export const getPointsMap = createSelector(selectPoints, PointsReducer.getPointsMap);
export const getPointsByParams = createSelector(selectPoints, PointsReducer.getPointsByParams);
export const getPoints = createSelector(selectPoints, PointsReducer.getPoints);
export const getSelectedPoint = createSelector(selectPoints, PointsReducer.getSelectedPoint);
export const getPointsViewer = createSelector(selectPoints, PointsReducer.getPointsViewer);
export const arePointsLoading = createSelector(selectPoints, PointsReducer.arePointsLoading);


export const getDriving = createSelector(selectDriving, DrivingReducer.getDriving);
export const getDrivingRoute = createSelector(selectDriving, DrivingReducer.getDrivingRoute);
